import { paths as auth, AuthPaths } from "@/router/paths/auth";
import { paths as app, AppPaths } from "@/router/paths/app";
import { paths as settings, SettingsPaths } from "@/router/paths/settings";

interface TopLevelPaths {
  auth: AuthPaths;
  app: AppPaths;
  settings: SettingsPaths;
}

export const paths: TopLevelPaths = {
  auth,
  app,
  settings,
};
